<script lang="ts">
	import Formatted from "./Formatted.svelte";

	interface TableRow {
		label: string;
		value: string;
		isEmail?: boolean;
		emailHref?: string;
	}

	const {
		rows,
		labelWidth = "w-auto",
	}: {
		rows: TableRow[];
		labelWidth?: string;
	} = $props();
</script>

<div class="bg-zms-grey rounded-2xl p-4 md:p-6">
	<table class="w-full text-optical-black text-sm md:text-base">
		<tbody class="space-y-3">
			{#each rows as row (row)}
				<tr class="block mb-3">
					<td class="inline-block {labelWidth} font-medium pr-2">
						<Formatted text={row.label} />
					</td>
					<td class="font-semibold">
						{#if row.isEmail && row.emailHref}
							<a href={row.emailHref} class="text-zms-blue hover:underline underline-offset-4">
								<Formatted text={row.value} />
							</a>
						{:else}
							<Formatted text={row.value} />
						{/if}
					</td>
				</tr>
			{/each}
		</tbody>
	</table>
</div>
